var map = {
	"./bg/article.md": "0cb5",
	"./bg/journals/index.md": "3368",
	"./bg/journals/neruosonology/neruosonology.md": "fba2",
	"./bg/news/petrov.md": "4fd3",
	"./bg/news/women-in-stroke.md": "12c3",
	"./bg/news/соня-каракънева-2019.md": "8b32",
	"./bg/етика.md": "9937",
	"./bg/инструкции.md": "daf2",
	"./bg/контакти.md": "58e8",
	"./bg/начало.md": "b68a",
	"./bg/редколегия.md": "a742",
	"./en/article.md": "2419",
	"./en/contacts.md": "fbc4",
	"./en/editors.md": "8136",
	"./en/ethics.md": "c90d",
	"./en/index.md": "e9f6",
	"./en/instructions.md": "d917",
	"./en/journals/index.md": "cc41",
	"./en/journals/neurosonology/neurosonology.md": "1982",
	"./en/news/eso-report-2019.md": "613b",
	"./en/news/petrov.md": "0ac2",
	"./en/news/women-in-stroke.md": "578c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8d7b";